export default "__VITE_ASSET__BXHpO06w__"